export default {
      id: "icon-share-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "img/icons.c2f64a3b.svg#icon-share",
      toString: function () {
        return this.url;
      }
    }